module.exports = "<section *ngIf=\"loading\">Loading Application\n  <app-spin-icon></app-spin-icon>\n</section>\n<section *ngIf=\"!loading\">\n  <dac-assessment-single-question-display [assessment]=\"assessment\" (onSubmit)=\"submit($event)\" [disabled]=\"saving\"></dac-assessment-single-question-display> \n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/take-assessment/take-assessment.component.html
// module id = ./src/app/assessments/take-assessment/take-assessment.component.html
// module chunks = main